import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AttachmentVisibilityCell } from './AttachmentVisibilityCell';
import { toBuildingAttachmentRow } from '../utils/toBuildingAttachmentRow';
const BUILDING_ID = 42;
// Mirrors `features.building_attachments.table.visibility_summary.*` (config/locales/frontend/en.yml).
const EN = {
    'visibility_summary.office_only': 'Office only',
    'visibility_summary.office_techs': 'Office · Techs',
    'visibility_summary.office_portal': 'Office · Customer portal',
    'visibility_summary.office_techs_portal': 'Office · Techs · Customer portal'
};
const translateFn = (key) => { var _a; return (_a = EN[key]) !== null && _a !== void 0 ? _a : key; };
function withRow(apiRow, showPortalOption = true) {
    return function Story() {
        const client = useMemo(() => new QueryClient({ defaultOptions: { queries: { retry: false } } }), []);
        const item = toBuildingAttachmentRow(apiRow, translateFn);
        return (React.createElement(QueryClientProvider, { client: client },
            React.createElement(AttachmentVisibilityCell, { item: item, buildingId: BUILDING_ID, showPortalOption: showPortalOption, translateFn: translateFn })));
    };
}
const meta = {
    title: 'Features/BuildingAttachments/AttachmentVisibilityCell',
    tags: ['autodocs'],
    parameters: { layout: 'padded' }
};
export default meta;
const BASE_ROW = {
    id: 1,
    name: 'report.pdf',
    attachmentCategoryId: null,
    categoryName: null,
    createdAt: '2026-09-15T14:30:00-04:00',
    fileSize: 655360,
    isPrivate: false,
    showOnCustomerPortal: false,
    url: 'https://cdn.example.com/report.pdf'
};
/** Office · Techs — the DB defaults (E2E-28). */
export const OfficeAndTechs = { render: withRow(BASE_ROW) };
/** Hidden from techs, published to the customer portal. */
export const OfficeAndPortal = {
    render: withRow(Object.assign(Object.assign({}, BASE_ROW), { isPrivate: true, showOnCustomerPortal: true }))
};
/**
 * The tenant lacks a customer portal (or has `has_show_all_attachments_in_customer_portal` on) —
 * the "Customer portal" checkbox is omitted entirely (`new.html.erb:44`).
 */
export const PortalOptionHidden = {
    render: withRow(BASE_ROW, false)
};
